module.exports = __webpack_public_path__ + "static/img/BG_Blue.png";